// Get All Contents

import {
  commonLabels,
  getFontSize,
  getFontSizeByMedium,
} from "../../util/commonLabelAndFontSize";
import { getQuestionText } from "../others";
import reduxStore from "../../../../../../src/redux/store";
// const fontSizeForDisplay = localStorage?.getItem("font_size") || "12";

// const fontSizeForDisplay = getFontSizeByMedium(mediumList, formData.medium_id);

export const getHeaderContent = (
  schoolname,
  examname,
  className,
  subject,
  marks,
  duration,
  displayTerms = false,
  displayHeader,
  termsText,
  formData,
) => {
  const logoAlignment =
    formData.logoPosition === "center"
      ? "center"
      : formData.logoPosition === "right"
        ? "flex-end"
        : "flex-start";

  const hasType1 = formData?.headerTypes?.includes("1");
  const hasType2 = formData?.headerTypes?.includes("2");
  const hasType3 = formData?.headerTypes?.includes("3");

  const state = reduxStore.getState();
  const mediumList = state.createQstnPaper?.mediumList || [];

  const selectedMedium = mediumList.find((m) => m.id === formData.medium_id);

  const mediumName = selectedMedium?.name?.toLowerCase() || "";

  function formatDuration(duration) {
    if (duration === undefined || duration === null || duration === "") {
      return "0 Min";
    }

    // If already formatted like "1 hour 5 minute"
    if (
      typeof duration === "string" &&
      duration.toLowerCase().includes("hour")
    ) {
      return duration;
    }

    // Extract number safely (even if "30 Min")
    const totalMinutes = parseInt(duration);

    if (isNaN(totalMinutes)) {
      return "0 Min";
    }

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    if (hours > 0 && minutes > 0) return `${hours} hour ${minutes} minute`;

    if (hours > 0) return `${hours} hour`;

    return `${minutes} Min`;
  }

  const labels = commonLabels[mediumName === "hindi" ? "hi" : "en"];

  return `<!-- HEADER_START -->
    ${
      // displayHeader === "true"
      //   ? `${
      //       formData?.headerType === "1"
      //         ? `<div style="font-family: 'Times New Roman'; font-size: medium; text-align: center;"><span style="font-family: 'times new roman', times; font-size: 14pt;"><strong><span style="font-size: 18pt;">${schoolname}&nbsp;</span></strong></span></div>`
      //         : `<div style="text-align: center;"><img style="width: ${formData?.headerImgWidth}%; height: ${formData?.headerImgHeight}vh;" src="${formData.headerImageUrl}" /></div>`
      //     }`
      //   : ""

      displayHeader === "true"
        ? `
    ${
      hasType2
        ? `
          <div style="text-align:center;">
            <img 
              src="${formData.headerImageUrl}"
              style="
                width:${formData?.headerImgWidth}%;
                height:${formData?.headerImgHeight}vh;
              "
            />
          </div>
        `
        : ""
    }
${
  hasType1 && hasType3
    ? `
      <div style="
        position:relative;
        width:100%;
        height:${Math.max(formData.logoHeight, 40)}px;
      ">

        <!-- Logo (LEFT, does NOT affect center) -->
        <img
          src="${formData.schoolLogoUrl}"
          style="
            position:absolute;
            left:0px;
            top:50%;
            margin-top:12px;  
            transform:translateY(-50%);
            width:${formData.logoWidth}%;
            height:${formData.logoHeight}vh;
            object-fit:contain;
          "
        />

        <!-- School Name (ALWAYS CENTERED) -->
        <div style="
          text-align:center;
          font-family:'Times New Roman';
          font-size:18pt;
          font-weight:bold;
          line-height:${Math.max(formData.logoHeight, 40)}px;
        ">
          ${schoolname}
        </div>

      </div>
    `
    : ""
}
    ${
      hasType1 && !hasType3
        ? `
          <div style="
            font-family:'Times New Roman';
            font-size:18pt;
            text-align:center;
            font-weight:bold;
          ">
            ${schoolname}
          </div>
        `
        : ""
    }
    ${
      hasType3 && !hasType1
        ? `
          <div style="
            display:flex;
            align-items:center;
            justify-content:${logoAlignment};
          ">
            <img 
              src="${formData.schoolLogoUrl}"
              style="
                width:${formData.logoWidth}%;
                height:${formData.logoHeight}vh;
                object-fit:contain;
              "
            />
          </div>
        `
        : ""
    }
  `
        : ""
    }

    
    <div style="text-align: center;"><span style="font-family: 'times new roman', times, serif; font-size: 14pt;"><strong>${examname}</strong></span></div>
    <div style="text-align: center;">&nbsp;</div> 
    <table style="border-collapse: collapse; width: 100%;">
  <tbody>
    <tr>
      <td style="text-align: left; padding: 2px; border: none; font-family: 'Times New Roman'; font-size: 14pt;">
        <strong>${labels.class}: </strong>${className}
      </td>
      <td style="text-align: right; padding: 2px; border: none; font-family: 'Times New Roman'; font-size: 14pt;">
        <strong>${labels.subject}: </strong>${subject}
      </td>
    </tr>
    <tr>
      <td style="text-align: left; padding: 2px; border: none; font-family: 'Times New Roman'; font-size: 14pt;">
        <strong>${labels.time}: </strong>${formatDuration(duration)} 
      </td>
      <td style="text-align: right; padding: 2px; border: none; font-family: 'Times New Roman'; font-size: 14pt;">
        <strong>${labels.maxMarks}: </strong>${marks}
      </td>
    </tr>
  </tbody>
</table>

    <!-- HEADER_END -->
    ${
      displayTerms === "true"
        ? `<h3>
    <span style="font-family: 'Times New Roman', Times, serif; font-size: 14pt; margin-bottom: 6px;">
    <strong>${labels.termsAndConditions}:</strong>
    </span>
    </h3>
    <pre style="margin: 0;"><span style="font-family: 'Times New Roman', Times, serif; font-size: 13pt;">${termsText.trim()}
    </span></pre>`
        : ""
    }
    `;
};

// <div style="font-family: 'Times New Roman', Times, serif; font-size: 14pt; margin-bottom: 6px;">
export function getCommonCategoryHeaderContent(sno, name, marks, children) {
  const fontSizeForDisplay = getFontSize();

  return `
  <div style="margin-bottom: 15px">
    <div style="font-family: 'Times New Roman', Times, serif; font-size: ${fontSizeForDisplay}pt; margin-bottom: 6px;">
      <div style="display: flex; justify-content: space-between;"><strong>${sno}. ${name}</strong> <strong>(${marks})</strong></div>
    </div>
    ${children}
  </div>`;
}

// export function getCommonContent(sno, question, marks) {
//   const questionText = getQuestionText(question.question_text);

//   return `
//   <div class="avoid-break-inside" style="font-family: 'Times New Roman', Times, serif; font-size: 14pt;">
//     <div style="margin-bottom: 4px;">${sno}. ${questionText} <span style="float: right;">(${marks})</span></div>
//   </div>`;
// }
export function getCommonContent(sno, question, marks) {
  const questionText = getQuestionText(question.question_text);
  const fontSizeForDisplay = getFontSize();

  // style="font-family: 'Times New Roman', Times, serif; font-size: 14pt;">
  return `
  <div class="avoid-break-inside" 
       style="font-family: 'Times New Roman', Times, serif; font-size: ${fontSizeForDisplay}pt;">

    <!-- Question -->
    <div style="margin-bottom: 4px;">
      ${sno}. ${questionText}
      <span style="float: right;">(${marks})</span>
    </div>

    <!-- Images centered below -->
    <div style="text-align: center; margin-top: 6px;">
      ${getImageHtml(question.images)}
    </div>

  </div>`;
}

// export function getType1Content(sno, question, marks) {
//   const questionText = getQuestionText(question.question_text);

//   return `
//   <div class="avoid-break-inside" style="font-family: 'Times New Roman', Times, serif; font-size: 14pt;">
//   <div style="margin-bottom: 4px; margin-top: 5px">${sno}. ${questionText} <span style="float: right;">(${marks})</span></div>
//     <ol style="list-style-type: lower-alpha; padding-left: 40px; margin: 2px 0;">
//       ${question.options
//         .map((q, i) => `<li style="margin: 2px 0;" key=${i + 1}>${q.text}</li>`)
//         .join(" ")}
//     </ol>
//   </div>`;
// }

export function getType1Content(sno, question, marks) {
  const questionText = getQuestionText(question.question_text);
  const fontSizeForDisplay = getFontSize();

  // style="font-family: 'Times New Roman', Times, serif; font-size: 14pt;">
  return `
  <div class="avoid-break-inside" 
       style="font-family: 'Times New Roman', Times, serif; font-size: ${fontSizeForDisplay}pt;">

    <!-- QUESTION TEXT -->
    <div style="margin-bottom: 4px; margin-top: 5px;">
      ${sno}. ${questionText}
      <span style="float: right;">(${marks})</span>
    </div>

    <!-- IMAGES BELOW QUESTION TEXT -->
    ${
      question.images?.length
        ? `<div style="margin: 8px 0;">
          ${getImageHtml(question.images)}
        </div>`
        : ""
    }

    <!-- OPTIONS -->
    <div style="margin-top: 5px;">
      <ol style="list-style-type: lower-alpha; padding-left: 40px; margin: 2px 0;" type="a">
        ${question.options
          .map(
            (q, i) => `<li style="margin: 2px 0;" key=${i + 1}>${q.text}</li>`,
          )
          .join(" ")}
      </ol>
    </div>

  </div>`;
}

export function getType16Content(sno, question, marks) {
  const questionText = getQuestionText(question.question_text);

  const columnAList = question.matching_options
    .map(
      (e) =>
        `<li style="margin-bottom: 12px;"><div style="width: 200px;">${e.column1_text}</div></li>`,
    )
    .join("");

  const columnBList = question.matching_options
    .map(
      (e) =>
        `<li style="margin-bottom: 12px;"><div style="width: 200px;">${e.column2_text}</div></li>`,
    )
    .join("");
  const fontSizeForDisplay = getFontSize();

  // <div class="avoid-break-inside" style="font-family: 'Times New Roman', Times, serif; font-size: 14pt;">
  return `
  <div class="avoid-break-inside" style="font-family: 'Times New Roman', Times, serif; font-size: ${fontSizeForDisplay}pt;">
    <div style="margin-bottom: 4px;">${sno}. ${questionText} <span style="float: right;">(${marks})</span></div>
    <div style="margin-left: 0px; margin-right: 12px;">
    <div style="display: flex; justify-content: left; text-align: center; font-weight: bold; margin-bottom: 4px;">
      <div style="width: 200px;">Column A</div>
      <div style="width: 200px; margin-left: 100px;">Column B</div>
    </div>

    <div style="display: flex;">
      <!-- Column A list -->
      <ol style="padding-left: 20px; margin: 0 0 0 30px;">
        ${columnAList}
      </ol>

      <!-- Column B list -->
      <ol style="padding-left: 20px; margin: 0; margin-left: 100px; list-style-type: lower-alpha;">
        ${columnBList}
      </ol>
    </div>

    </div>
</div>`;
}

export const getCategoryMarksContent = (marks, questions, categoryMarks) => {
  // return `${marks} <small>X</small> ${questions} = ${categoryMarks}`;
  return `${questions} <small>X</small> ${marks} = ${categoryMarks}`;
};

export function getType6Content(sno, question, marks) {
  const passage = question.passage_text || "";
  const subQuestions = question.subQuestions || [];

  const subContent = subQuestions
    .map(
      (subQ, i) => `
        <div style="margin-top: 8px;">
          ${String.fromCharCode(97 + i)}) ${subQ.question_text || ""}
        </div>`,
    )
    .join("");
  const fontSizeForDisplay = getFontSize();

  // <div class="avoid-break-inside" style="font-family: 'Times New Roman', Times, serif; font-size: 14pt; margin-bottom: 10px;">
  return `
    <div class="avoid-break-inside" style="font-family: 'Times New Roman', Times, serif; font-size: ${fontSizeForDisplay}pt; margin-bottom: 10px;">
      <div style="margin-bottom: 6px;"><strong>${sno}.</strong> ${passage} </div>
      <div style="margin-left: 20px; margin-bottom: 8px; white-space: pre-wrap;"></div>
      <div style="margin-left: 30px;">
       <span style="float: right;">(${marks})</span> ${subContent}
      </div>
    </div>`;
}
export function getImageHtml(images = []) {
  if (!images || images.length === 0) return "";

  const commonStyle =
    "max-height: 140px; object-fit: contain; display: block; margin: 0 auto;";

  // 1 image → centered full width
  if (images.length === 1) {
    return `
      <div style="margin: 10px 0; text-align: center;">
        <img 
          src="${images[0].image_url}" 
          style="width: 60%; ${commonStyle}" 
        />
      </div>
    `;
  }

  // 2 images → centered, equal width
  if (images.length === 2) {
    return `
      <div style="display: flex; justify-content: center; gap: 10px; margin: 10px 0;">
        ${images
          .map(
            (img) => `
            <img 
              src="${img.image_url}" 
              style="width: 45%; ${commonStyle}" 
            />
          `,
          )
          .join("")}
      </div>
    `;
  }

  // 3 images → centered, equal width
  if (images.length === 3) {
    return `
      <div style="display: flex; justify-content: center; gap: 10px; margin: 10px 0;">
        ${images
          .map(
            (img) => `
            <img 
              src="${img.image_url}" 
              style="width: 30%; ${commonStyle}" 
            />
          `,
          )
          .join("")}
      </div>
    `;
  }

  // 4 images → grid 2 × 2, centered
  if (images.length === 4) {
    return `
      <div 
        style="
          display: grid; 
          grid-template-columns: repeat(2, 1fr); 
          gap: 10px; 
          justify-items: center; 
          margin: 10px 0;
        "
      >
        ${images
          .map(
            (img) => `
            <img 
              src="${img.image_url}" 
              style="width: 90%; ${commonStyle}" 
            />
          `,
          )
          .join("")}
      </div>
    `;
  }

  // More than 4 → stacked but centered
  return `
    <div style="margin: 10px 0; text-align: center;">
      ${images
        .map(
          (img) => `
          <img 
            src="${img.image_url}" 
            style="width: 60%; ${commonStyle}; margin-bottom: 8px;" 
          />
        `,
        )
        .join("")}
    </div>
  `;
}
